import { createFileRoute } from "@tanstack/react-router"
import { ReferralPage } from "@/routes/referral"

export const Route = createFileRoute("/$lang/referral")({
  component: ReferralPage,
})
